import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { MenuService } from './menu.service';
import { SettingsService } from './settings.service';
@Injectable({
  providedIn: 'root',
})
export class StartupService {
  constructor(
    private readonly menu: MenuService,
    private readonly http: HttpClient,
    private readonly settings: SettingsService
  ) {}
  load(): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http
        .get('assets/data/menu.json?_t=' + Date.now())
        .pipe(
          catchError(res => {
            resolve(null);
              return throwError(() => new Error(res));
          })
        )
          .subscribe({
              next: (res: any) => {
                  this.menu.recursMenuForTranslation(res.menu, 'menu');
                  this.menu.set(res.menu);
              },
              error: (err: any) => reject(new Error('Promise rejected: ' + err)),
              complete: () => resolve(null)
          });
    });
  }
}
